import React from 'react';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import useLogoutHandler from '../../api/auth/useLogoutHandler';

const LogoutTrigger: React.FC = () => {
  const logout = useLogoutHandler(() => {
    window.location.replace('/');
  });
  React.useEffect(() => {
    logout();
  }, [logout]);
  return null;
};

const AuthErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ErrorBoundary
    renderFallback={({ error }) => {
      if (error.name === 'RootTaxonomyNotFoundError') {
        return <LogoutTrigger />;
      }
      return <></>;
    }}
  >
    {children}
  </ErrorBoundary>
);

AuthErrorBoundary.displayName = 'AuthErrorBoundary';

export default AuthErrorBoundary;
